import Masthead from "./common/Masthead";
import { useLanguage } from "../i18n/LanguageContext";

export default function Privacy() {
  const { t } = useLanguage();
  return (
    <div className="content-page" lang="de">
      <Masthead title="Datenschutz" />
      <div className="content-card">
        {t("legal.germanOnly") && (
          <p className="legal-note" lang="en">
            {t("legal.germanOnly")}
          </p>
        )}
        <h2>1. Verantwortlicher</h2>
        <p>
          Verantwortlich f&uuml;r die Datenverarbeitung auf dieser Website
          ist:
          <br />
          Elina Sch&auml;fer
          <br />
          Waltari-Bergmannstr. 2
          <br />
          36211 Alheim
          <br />
          E-Mail: elina@elfgaben.de
        </p>

        <h2>2. Ihre Planungsdaten bleiben in Ihrem Browser</h2>
        <p>
          focussuite.de speichert Agenda-Eintr&auml;ge, Kartennamen und
          Zeiten ausschlie&szlig;lich im Adressfeld Ihres Browsers (in der
          URL) sowie in Ihrem lokalen Browserverlauf. Diese Daten werden zu
          keinem Zeitpunkt an einen Server oder eine Datenbank des Betreibers
          &uuml;bertragen oder dort gespeichert. Schlie&szlig;en Sie den Tab
          oder l&ouml;schen Sie den Verlauf, sind diese Daten unwiederbringlich
          weg. Teilen Sie hingegen den Link zu einer Agenda &ndash; etwa per
          Chat oder E-Mail &ndash; sind die darin enthaltenen Planungsdaten
          f&uuml;r jede Person lesbar, die diesen Link erh&auml;lt.
        </p>

        <h2>3. Hosting</h2>
        <p>
          Diese Website wird bei Netlify, Inc., 2325 3rd Street, Suite 215,
          San Francisco, CA 94107, USA, gehostet. Beim Aufruf der Seite
          erhebt Netlify automatisch technische Zugriffsdaten in sogenannten
          Server-Logfiles, die Ihr Browser &uuml;bermittelt, unter anderem:
        </p>
        <ul>
          <li>IP-Adresse</li>
          <li>Datum und Uhrzeit der Anfrage</li>
          <li>aufgerufene Seite und &uuml;bertragene Datenmenge</li>
          <li>Browsertyp und Betriebssystem</li>
          <li>anfragender Provider</li>
        </ul>
        <p>
          Diese Verarbeitung erfolgt auf Grundlage unseres berechtigten
          Interesses an einem sicheren und st&ouml;rungsfreien Betrieb der
          Website (Art. 6 Abs. 1 lit. f DSGVO). Da Netlify in den USA
          ans&auml;ssig ist, ist dabei eine &Uuml;bermittlung
          personenbezogener Daten in ein Drittland nicht ausgeschlossen;
          Netlify stellt hierf&uuml;r EU-Standardvertragsklauseln sowie eine
          Auftragsverarbeitungsvereinbarung nach Art. 28 DSGVO bereit.
        </p>

        <h2>4. Cookies, Tracking &amp; externe Ressourcen</h2>
        <p>
          Diese Website setzt keine Cookies, kein Analyse-Tool und keine
          Tracking- oder Marketing-Dienste ein. Es findet keine
          Profilbildung statt, und es werden keine Konten oder Logins
          angelegt. Auch Schriftarten werden nicht von Google Fonts oder
          einem anderen externen Anbieter nachgeladen, sondern liegen direkt
          auf dieser Website &ndash; beim Aufruf der Seite wird also keine
          Verbindung zu Google-Servern aufgebaut.
        </p>

        <h2>5. Ihre Rechte</h2>
        <p>Ihnen stehen nach der DSGVO folgende Rechte zu:</p>
        <ul>
          <li>
            Auskunft &uuml;ber die zu Ihrer Person gespeicherten Daten (Art.
            15 DSGVO)
          </li>
          <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
          <li>L&ouml;schung Ihrer Daten (Art. 17 DSGVO)</li>
          <li>Einschr&auml;nkung der Verarbeitung (Art. 18 DSGVO)</li>
          <li>Daten&uuml;bertragbarkeit (Art. 20 DSGVO)</li>
          <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
        </ul>
        <p>
          Da focussuite.de keine personenbezogenen Planungsdaten auf
          eigenen Servern speichert, betreffen diese Rechte in der Praxis vor
          allem die in Abschnitt 3 genannten Server-Logfiles. Wenden Sie sich
          hierf&uuml;r an die oben genannte Kontaktadresse.
        </p>

        <h2>6. Beschwerderecht</h2>
        <p>
          Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbeh&ouml;rde
          &uuml;ber die Verarbeitung Ihrer personenbezogenen Daten zu
          beschweren (Art. 77 DSGVO).
        </p>

        <p className="legal-note">
          Diese Datenschutzerkl&auml;rung beschreibt den tats&auml;chlichen
          technischen Aufbau dieser Anwendung und ersetzt keine individuelle
          Rechtsberatung.
        </p>
      </div>
    </div>
  );
}
